import { render, staticRenderFns } from "./CompanyTariffSelect.vue?vue&type=template&id=4a93eefa&scoped=true&"
import script from "./CompanyTariffSelect.vue?vue&type=script&lang=js&"
export * from "./CompanyTariffSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a93eefa",
  null
  
)

export default component.exports